import contentService from '../services/content.service';

const handlers = {
    content: {
        strings: {
            set: 'strings_set'
        },
        links: {
            set: 'links_set'
        }
    }
};

const initVuexState = function(state) {
    state.content = {
        strings: [],
        links: []
    };
};

const initGetters = function(getters) {
    getters.content = state => state.content;
};

const initActions = function(actions) {
    actions[handlers.content.strings.set] = ({ commit }, strings) => commit(handlers.content.strings.set, strings);
    actions[handlers.content.links.set] = ({ commit }, links) => commit(handlers.content.links.set, links);
};

const initMutations = function(mutations) {
    mutations[handlers.content.strings.set] = (state, strings) => (state.content.strings = strings);
    mutations[handlers.content.links.set] = (state, links) => (state.content.links = links);
};

let stringsPromise = null;
let linksPromise = null;

const initAppState = function(appState, store) {
    appState.content = {
        strings: {
            get: () => store.getters.content.strings,
            getById: stringId => store.getters.content.strings.find(s => s.id === stringId),
            getByName: stringName => store.getters.content.strings.find(s => s.name === stringName),
            ensure: () => {
                if (!stringsPromise) {
                    stringsPromise = contentService.getAllStrings();
                    stringsPromise.then(strings => {
                        store.dispatch(handlers.content.strings.set, strings);
                    });
                }
                return stringsPromise;
            }
        },
        links: {
            get: () => store.getters.content.links,
            getById: linkId => store.getters.content.links.find(l => l.id === linkId),
            getByName: linkName => store.getters.content.links.find(l => l.name === linkName),
            ensure: () => {
                if (!linksPromise) {
                    linksPromise = contentService.getAllLinks();
                    linksPromise.then(links => {
                        store.dispatch(handlers.content.links.set, links);
                    });
                }
                return linksPromise;
            }
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/content.js